import * as React from "react";
import { styled } from "@mui/material/styles";
import Editor from "../editor/Editor";
import { inject } from "mobx-react";
import { observer } from "mobx-react";
import NarrativeBuilder from "../editor/NarrativeBuilder";
import Modal from "react-modal";
import autobind from "autobind-decorator";
import NodeLayer, { questionTypes } from "../editor/NodeLayer";
import { observable } from "mobx";
import { RadioGroup, Radio } from "react-radio-group";
import CheckboxGroup from "react-checkbox-group";
import QuestionnaireRenderer, {
  QuestionnaireState,
} from "./QuestionnaireRenderer";

const StyledRadioGroup = styled(RadioGroup)({
  margin: "12px",
  fontSize: "14",
  color: "rgb(120, 120, 120)",
});

const CheckboxContainer = styled("div")({
  margin: "12px",
  fontSize: "14",
  color: "rgb(120, 120, 120)",
});

const Span = styled("div")({
  display: "flex",
  flexGrow: 1,
});

const ModalNarrative = styled("p")({
  margin: "12px",
  fontSize: "14",
  color: "rgb(120, 120, 120)",
});

const ModalQuestion = styled("p")({
  margin: "12px",
  fontSize: "32px",
  minHeight: "32px",
  color: "rgb(80, 80, 80)",
});

const ModalButton = styled("button")({
  width: "64px",
  lineHeight: "28px",
  height: "28px",
  fontSize: "12px",
  background: "rgb(155, 66, 227)",
  color: "white",
  cursor: "pointer",
  borderRadius: "4px",
  outline: "none",
  border: "none",
  transition: "all 100ms ease-in-out",
  textAlign: "center",
});

const CancelButton = styled(ModalButton)({
  backgroundColor: "rgb(211, 69, 91)",
  marginRight: "10px",
});
const BackButton = styled(ModalButton)({
  backgroundColor: "rgb(26, 174, 159)",
  marginRight: "12px",
});
const NextButton = styled(ModalButton)({
  backgroundColor: "rgb(26, 174, 159)",
  marginRight: "12px",
});

const ButtonRow = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-end",
  marginTop: "18px",
});

const TextInput = styled("input")({
  outline: "none",
  border: "1px solid rgb(220, 220, 220)",
  fontSize: "12px",
  padding: "8px",
  color: "rgb(80, 80, 80)",
  resize: "none",
  margin: "12px",

  "&:focus": {
    border: "1px solid rgb(180, 180, 180)",
  },
});

type QuestionnaireModalProps = {
  editor?: Editor;
  className?: string;
  style?: React.CSSProperties;
};

const modalStyle = {
  overlay: {
    outline: "none",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.6)",
  },
  content: {
    background: "rgb(240, 240, 240)",
    width: "95%",
    maxWidth: "480px",
    borderRadius: "4px",
    padding: "20px",
    maxHeight: "60%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
};

@inject("editor")
@observer
export default class QuestionnaireModal extends React.Component<QuestionnaireModalProps> {
  modalContainer: HTMLElement = null;

  narrative = "";

  questionnaireState: QuestionnaireState;

  @autobind
  closeModal() {
    this.props.editor.setInferenceMode("None");
  }

  @autobind
  handleOpen() {
    var { editor } = this.props;
    this.narrative = "";
    var startLayer = (
      editor.inferenceMode == "SelectedLayer"
        ? editor.selectedLayer
        : editor.startLayer
    ) as NodeLayer;
    this.questionnaireState = new QuestionnaireState(startLayer);
    this.forceUpdate();
  }

  @autobind
  handleNext() {
    if (this.questionnaireState.currentQuestionNode.answer.length > 0) {
      this.questionnaireState.handleNext();
    }
  }

  @autobind
  handlePrevious() {
    this.questionnaireState.handlePrevious();
  }
  isComplete(): boolean {
    if (this.questionnaireState == null) {
      return false;
    }

    return this.questionnaireState.isComplete;
  }

  renderQuestion() {
    var { editor } = this.props;
    return (
      <React.Fragment key="question-view">
        {this.questionnaireState != null ? (
          <QuestionnaireRenderer
            editor={editor}
            state={this.questionnaireState}
          />
        ) : null}
        <ButtonRow>
          <CancelButton onClick={this.closeModal}> EXIT </CancelButton>
          <Span></Span>
          <BackButton onClick={this.handlePrevious}>BACK</BackButton>
          <NextButton onClick={this.handleNext}> NEXT </NextButton>
        </ButtonRow>
      </React.Fragment>
    );
  }

  renderNarrative() {
    if (this.narrative == "") {
      var { editor } = this.props;
      var builder = new NarrativeBuilder(editor);
      let res = builder.buildNarrative();
      this.narrative = res.narrative;
    }

    return (
      <React.Fragment key="question-view">
        <ModalQuestion> Narrative </ModalQuestion>
        {this.narrative.split(".").map((entry, index) => (
          <ModalNarrative key={index}>{`${entry}.`}</ModalNarrative>
        ))}
        <ButtonRow>
          <NextButton onClick={this.closeModal}> OK </NextButton>
        </ButtonRow>
      </React.Fragment>
    );
  }

  render() {
    var { editor } = this.props;

    if (this.modalContainer == null) {
      this.modalContainer = document.getElementById("app-content");
    }

    return (
      <Modal
        style={modalStyle}
        isOpen={editor.inferenceMode != "None"}
        appElement={this.modalContainer}
        onRequestClose={this.closeModal}
        onAfterOpen={this.handleOpen}
      >
        {this.isComplete() ? this.renderNarrative() : this.renderQuestion()}
      </Modal>
    );
  }
}
